const icons = {
    delete: '<span class="btn btn-link negative"><i class="fa fa-trash"></i></span>',
    edit: '<span class="btn btn-primary positive"><i class="fa fa-pencil"></i></span>',
    groups: '<span class="btn btn-primary positive"><i style="top:0px; color: var(--buttonIconColor) !important;" class="fa fa-graduation-cap"></i></span>',
    invite: '<span class="btn btn-primary positive"><i class="fa fa-envelope"></i></span>',
    download: '<span class="btn btn-primary positive"><i class="fa fa-download"></i></span>',
    preview: '<span class="btn btn-neutral neutral"><i class="fas fa-external-link-alt"></i></span>',
    copy: '<span class="btn btn-primary neutral"><i class="fa fa-copy" aria-hidden="true"></i></span>',
    stop: '<span class="btn btn-primary positive"><i class="fas fa-stop-circle"></i></span>',
    users: '<span class="btn btn-primary neutral"><i class="fa fa-users"></i></span>',
    curriculum_info: {
        classic: '<span class="btn btn-link"><i class="fa fa-file" ></i></span>',
        default: '<span class="btn btn-link no-padding"><img class="cursor-pointer" style="height: 35px; width: 35px;" src="/images/icons/curriculum_auswertung.svg" /></span>'
    },
    chart: '<span class="btn btn-link"><i class="fas fa-chart-bar"></i></span>',
    check: '<span class="btn btn-link"><i class="fa fa-check-square-o"></i></span>',
    dispatch: '<span class="btn btn-primary positive"><i class="fa fa-paper-plane"></i></span>',
};

window.icons = icons;


// WEBPACK FOOTER //
// ./resources/assets/js/icons.js